const getFullNameOrUserName = (currentUser) => {
  if (currentUser) {
    const { given_name, family_name, email } = currentUser;
    return given_name && family_name ? `${given_name} ${family_name}` : email;
  }
  return '';
};

export default getFullNameOrUserName;

export const getUserEmail = (user) => {
  if (!user) return '';

  const { email } = user;

  return email || '';
};

/**
 * @param {Object} user A user object.
 * @returns true if user's give_name AND family_name is not empty(or null, undefined). Otherwiser return false.
 */
export const isUserNameValid = (user) => {
  if (!user) return false;

  const { given_name, family_name } = user;

  return (
    given_name &&
    given_name.trim() !== '' &&
    family_name &&
    family_name.trim() !== ''
  );
};



// WEBPACK FOOTER //
// ./src/utils/user.js